import { ComponentRoute } from '@/classes'

const GLMappingRoutes = {
  GLMappingView: new ComponentRoute('/glmapping', 'GLMappingView')
}

export default GLMappingRoutes
